import * as Yup from 'yup';

import { medicationsFieldArrayValidation } from 'src/app/components/PageSections/DoctorTransferForm/MedicationsFieldArray/MedicationsFieldArrayValidation';

export const validation = () => {
  return Yup.object().shape({
    medications: medicationsFieldArrayValidation,
  });
};
